import FilterMultiselect from "./multiselect";
import Classes from "classnames";
import React from "react";


export default class FilterSelectorRag extends FilterMultiselect {

    render() {

        const curValue = this.props.filter.getValue();
        const options = [null, 0, 1, 2];

        return (
            <div className="block-content filter-multiselect">

                {options.map((v, key)=>{

                    const selected = curValue.includes(v);

                    let renderValue;
                    if (_.isNil(v)) renderValue = <div className="name" onClick={this.onItemClick.bind(this,v)}>{"Not set"}</div>;
                    else {
                        const raqClass = Classes('gd-health-icon s20',{
                            'low-type':    v===0,
                            'medium-type': v===1,
                            'high-type':   v===2,
                        });
                        renderValue = <div className={raqClass} onClick={this.onItemClick.bind(this,v)}></div>
                    }

                    return (
                        <div key={key} className={Classes("type-option", {'selected': selected})}>
                            <div className={Classes('gd-cb-12',{selected: selected})} onClick={this.onCheckboxClick.bind(this,v)}> </div>
                            {renderValue}
                            <div className="cf"> </div>
                        </div>
                    );
                })}

            </div>
        );
    }


}